export default __webpack_public_path__ + "media/color/cred-276d024a.svg";